// Curated, widely-documented Tesla service bulletins & known service actions.
// Sourced from public service records and owner-reported goodwill repairs —
// NOT an official Tesla list. Matched by model + year range.

export const TSB_ENTRIES = [
  {
    models: ["Model 3"],
    years: [2017, 2021],
    system: "Suspension",
    title: "Front upper control arm squeak / creak",
    note: "Well-known early Model 3 item — Tesla revised the part. Often replaced free under goodwill even out of basic warranty.",
  },
  {
    models: ["Model 3", "Model Y"],
    years: [2021, 2023],
    system: "HVAC",
    title: "Heat pump sensor — weak cabin heat in extreme cold",
    note: "Documented cold-weather service action (recalled in Canada). If heat fades below ~10°F, service will check the heat pump sensor.",
  },
  {
    models: ["Model 3", "Model Y"],
    years: [2017, 2026],
    system: "Charging",
    title: "Charge port latch sticking in freezing weather",
    note: "Known cold-climate item — service can replace the latch actuator. OTA improvements help but hardware swaps are common.",
  },
  {
    models: ["Model S"],
    years: [2012, 2018],
    system: "Infotainment",
    title: "MCU1 flash memory (eMMC) wear",
    note: "Subject of an official recall — blank/rebooting center screen qualifies for a free upgrade. Worth confirming it was done on used cars.",
  },
  {
    models: ["Model S", "Model X"],
    years: [2016, 2020],
    system: "Body",
    title: "Door handle / harness wear",
    note: "High-wear item on this generation. Service centers frequently replace under warranty — mention any slow or unresponsive handle.",
  },
  {
    models: ["Model Y"],
    years: [2020, 2022],
    system: "Body",
    title: "Liftgate alignment & water ingress",
    note: "Early-build Model Y item — realignment and updated seals are a quick, commonly-covered visit.",
  },
  {
    models: ["Model S", "Model X", "Model 3", "Model Y"],
    years: [2012, 2021],
    system: "LV Battery",
    id: "lv_battery",
    title: "12V lead-acid battery proactive replacement",
    note: "Pre-2022 cars use a ~4-year 12V battery. Service replaces it cheaply — proactively swapping avoids a no-start tow.",
  },
];

export function matchTsbs(model, year) {
  if (!model) return [];
  const y = Number(year) || new Date().getFullYear();
  return TSB_ENTRIES.filter(
    (t) => t.models.includes(model) && y >= t.years[0] && y <= t.years[1]
  );
}
